import React from 'react';
import withIcon from '../utilities/withIcon';

const IconUserFilled = () => {
  return (
    <g>
      <path d="m11.1924 2.1516a3.4447 3.4447 0 0 0 -3.1924-1.9995 3.4447 3.4447 0 0 0 -3.1924 2 5.602 5.602 0 0 0 .5161 4.99 3.1937 3.1937 0 0 0 2.6763 1.6291 3.1946 3.1946 0 0 0 2.6768-1.63 5.6 5.6 0 0 0 .5156-4.9896z" />
      <path d="m13.1748 10.5749a7.76 7.76 0 0 1 -2.5254-1.2607.3711.3711 0 0 0 -.5308.0806l-2.1186 3.0127-2.1182-3.0127a.3711.3711 0 0 0 -.5308-.0806 7.76 7.76 0 0 1 -2.5254 1.2607c-1.7211.5757-2.6947 1.087-2.6947 4.9019a.3709.3709 0 0 0 .3711.3711h14.996a.3709.3709 0 0 0 .3711-.3711c0-3.8149-.9736-4.3262-2.6943-4.9019z" />
    </g>
  );
};

export default withIcon(IconUserFilled);
